export default {
  active: state => state.active,
  items: state => state.items,
  hasnav: (state) => {
    return state.items.length > 0
  }
}
